export const getProfileTitle = (isLoggedin: boolean, firstName?: string, isLoading?: boolean): string => {
  if (!isLoggedin) {
    return 'Войти';
  }
  if (isLoading) {
    return '';
  }
  if (!firstName) {
    return 'Профиль';
  }
  if (firstName.length > 10) {
    return firstName.slice(0, 10) + '.';
  }
  return firstName;
};
